import React from 'react'
import AdminPageWithSmartview from 'pages/app/AdminPageWithSmartview'
import { Collection, ModelContext } from '@morningtrain/react-resources'
import { DateFilter, PeriodFilter, SearchFilter, SelectedDepartmentFilter, SwitchFilter } from 'support/filters'
import Calendar from 'pages/app/vacation/Calendar'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { Translation, Translator } from '@morningtrain/react-translations'
import * as UI from 'ui'
import { observable } from 'mobx'
import UpdateModelOnChange from 'support/utilities/UpdateModelOnChange'
import moment from 'moment'
import * as Displays from 'support/displays'
import {Env} from "@morningtrain/helpers";

export default function Vacation () {
  const hasWaiter = Env.get('globals.has_waiter');
  const hasKitchen = Env.get('globals.has_kitchen');

  const roles = [];
  hasWaiter ? roles.push('waiter'): false;
  hasKitchen ? roles.push('kitchen'): false;

  return (
    <AdminPageWithSmartview>
      <Translator namespace='hr.vacation'>

        <Collection resourceName='vacation.vacation_requests' operationName='custom_calendar'>
          <SelectedDepartmentFilter />

          <UI.PageHeader title={<TranslatedTitle name='title' />}>
            <UI.Legend>
              <UI.LegendItem color='bg-available'>
                <Translation name='legend.approved' />
              </UI.LegendItem>
              <UI.LegendItem color='bg-red-600'>
                <Translation name='legend.declined' />
              </UI.LegendItem>
              <UI.LegendItem color='bg-pending'>
                <Translation name='legend.pending' />
              </UI.LegendItem>
              <UI.LegendItem color='bg-blue-300'>
                <Translation name='legend.planned_shift' />
              </UI.LegendItem>
              <UI.LegendItem color='bg-gray-200'>
                <Translation name='legend.worked_shift' />
              </UI.LegendItem>
            </UI.Legend>
          </UI.PageHeader>

          <ModelContext.Provider value={observable.map()}>

            <UI.ButtonWrap className='mt-4 mb-4'>
              <div className='m-1'>
                <UpdateModelOnChange
                  name='period'
                  modify={from => {
                    return { from, to: !from ? null : moment(from).add(3, 'months').format('YYYY-MM-DD') }
                  }}
                >
                  <DateFilter name='from' label={false} shouldCloseOnSelect>
                    <span> - </span>
                    <Displays.Date name='period.to' dateFormat='DD-MM-YYYY' />
                  </DateFilter>
                </UpdateModelOnChange>
              </div>
              <div className='button-tabs-container'>
                <SearchFilter label={false} />
              </div>
              <SwitchFilter
                enum='employment_type_category' only={roles} name='category'
                allowNull
              />
              <SwitchFilter enum='vacation_request_type' name='type' allowNull />
              <SwitchFilter enum='request_status' name='status' allowNull />
            </UI.ButtonWrap>

            <Calendar />

          </ModelContext.Provider>

        </Collection>

      </Translator>
    </AdminPageWithSmartview>
  )
}
